import type { AthenaRightKey } from "../../rights/key.ts";
import { missingRequiredRights } from "../../rights/matching.ts";
import {
	AUTHORIZATION_PLATFORM_WRITE,
	AUTHORIZATION_ROLES_WRITE,
	ORGANIZATION_LIFECYCLE_DELETE,
	ORGANIZATION_MEMBERS_INVITE,
	ORGANIZATION_MEMBERS_WRITE,
} from "./catalog.ts";
import type { AuthorizationCapabilities } from "./types.ts";

export function capabilitiesFromRights(
	rights: readonly AthenaRightKey[],
): AuthorizationCapabilities {
	const holds = (required: AthenaRightKey) =>
		missingRequiredRights(rights, [required]).length === 0;
	const canManageMembers = holds(ORGANIZATION_MEMBERS_WRITE);
	return {
		canChangeMemberRole: canManageMembers,
		canDeleteOrganization: holds(ORGANIZATION_LIFECYCLE_DELETE),
		canInviteMembers: canManageMembers || holds(ORGANIZATION_MEMBERS_INVITE),
		canManageOrganizationRoles: holds(AUTHORIZATION_ROLES_WRITE),
		canManagePlatformRoles: holds(AUTHORIZATION_PLATFORM_WRITE),
		canRemoveMember: canManageMembers,
	};
}
